import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { promptsToolGroupIcon } from './toolGroupIcon';
import { readPromptInputSchema } from './botAiToolInputSchemas';

export { readPromptInputSchema };

export const readPromptOutputSchema = z.object({
  prompt: z
    .unknown()
    .nullable()
    .describe(
      'Prompt row or null if not found. Validated full shape when `select` is omitted; otherwise matches expanded flat `select` mask.',
    ),
});

export type ReadPromptInput = z.infer<typeof readPromptInputSchema>;
export type ReadPromptOutput = z.infer<typeof readPromptOutputSchema>;

export const readPrompt: AiTool<undefined, ReadPromptInput, ReadPromptOutput> = {
  id: 'readPrompt',

  group: 'prompts',

  ...promptsToolGroupIcon,

  userSelect: false,

  access: 'READ',

  tool: tool({
    description:
      'Load a single prompt by id. Omit `select` for the default edit mask (including nested child prompts); pass a flat `{ fieldName: true }` mask for specific fields. Use `childPrompts: true` for nested child prompts; use `versions: true` for PromptVersion history (version, createdAt, name, description, text).',
    inputSchema: zodSchema(readPromptInputSchema),
    outputSchema: zodSchema(readPromptOutputSchema),
  }),
};
